import { Dispatch, SetStateAction, useRef } from 'react';
import { Link } from 'react-router-dom';
import OpacityAnimation from '../../../../components/OpacityAnimation';
import Pagination from '../../../../components/Pagination';
import { SecondaryButton } from '../../../../components/SecondaryButton';
import useGetGeneralAppData from '../../../../hooks/useGetGeneralAppData';
import { Header } from './styles';

interface ListHeaderInterface {
  doesListExists: boolean;
  hasError: boolean;
  filteredListLength: number;
  singularLabel: string;
  pluralLabel: string;
  pagesQuantity: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  downloadExcel: () => void;
  filePathDownload: string;
  setImportModalShow: Dispatch<SetStateAction<boolean>>;
}

export default function ListHeader({
  doesListExists,
  hasError,
  filteredListLength,
  singularLabel,
  pluralLabel,
  pagesQuantity,
  currentPage,
  onPageChange,
  downloadExcel,
  filePathDownload,
  setImportModalShow,
}: ListHeaderInterface) {
  const downloadExampleFileRef = useRef<HTMLAnchorElement | null>(null);

  const { permissions } = useGetGeneralAppData();
  const workplacesPermissions = permissions.find((x) => x.codPag === 4);
  return (
    <OpacityAnimation delay={0.1}>
      <Header doesListExists={doesListExists} apiFetched={!hasError}>
        {(doesListExists) && (
          <div className="leftAlignment">
            <strong>
              {filteredListLength}
              {' '}
              {filteredListLength === 1 ? singularLabel : pluralLabel}
            </strong>
            <Pagination
              pagesQuantity={pagesQuantity}
              handlePageChange={onPageChange}
              currentPage={currentPage}
            />
          </div>
        )}
        <div className="actionButtons">
          {(doesListExists && workplacesPermissions?.imprimir) && (
            <button type="button" onClick={downloadExcel}>
              Download
            </button>
          )}
          {workplacesPermissions?.incluir && (
            <>
              <Link
                to={filePathDownload}
                target="_blank"
                download
                style={{ display: 'none' }}
                ref={downloadExampleFileRef}
              />
              <SecondaryButton onClick={() => { downloadExampleFileRef.current!.click();}}>
                  Exemplo CSV
              </SecondaryButton>
              <button type="button" onClick={() => setImportModalShow(true)}>
                Importar CSV
              </button>
              <Link to="/workplaces/new">
                Novo local de trabalho
              </Link>
            </>
          )}
        </div>
      </Header>
    </OpacityAnimation>
  );
}
